// extracted by css-extract-rspack-plugin
export default {"arrowLink":"_f2367091","noInnerRightSpacing":"_1b3f7e96","noInnerLeftSpacing":"_bc348ad","arrow":"_faf44131","arrowFiller":"_177e3969"};